<!-- Footer -->
<div class="box">
  <div class="columns">
    <div class="field column">
      <label class="label">Name</label>
      <div class="control">
        <input class="input" type="text" placeholder="Name" [id]="nameId">
      </div>
    </div>

    <div class="field column">
      <label class="label">Email</label>
      <div class="control has-icons-left has-icons-right">
        <input class="input" type="email" placeholder="Enter your email address" value="" [id]="emailId">
        <span class="icon is-small is-left">
          <i class="fas fa-envelope"></i>
        </span>
      </div>
    </div>
  </div>

  <div class="columns">
    <div class="field column is-one-fifth">
      <label class="label">Subject</label>
      <div class="control">
        <div class="select">
          <select [id]="subjectId">
            <option>Booking</option>
            <option>Other</option>
          </select>
        </div>
      </div>
    </div>
    <div class="field column is-one-fifth">
      <label class="label">Phone</label>
      <div class="control">
        <input class="input" type="text" placeholder="Phone" [id]="phoneId">
      </div>
    </div>
    <div class="column">
      <div class="questions-comments">Questions or Comments?  <span class="book-us">Book Us!</span>  Get in Touch:</div>
      <div class="social-media">
        <a class="button" href="https://www.facebook.com/theslamm2" target="_blank">
          <img src="../../assets/images/f_logo_RGB-Black_100.png" height="24" width="24">
        </a>
        <a class="button" href="https://www.instagram.com/theslamm" target="_blank">
          <img src="../../assets/images/glyph-logo_May2016.png" height="24" width="24">
        </a>
      </div>
    </div>
  </div>

  <div class="field">
    <label class="label">Message</label>
    <div class="control">
      <textarea class="textarea" placeholder="Enter your message" [id]="messageId"></textarea>
    </div>
  </div>

  <div class="field is-grouped">
    <div class="control">
      <button class="button is-link" (click)="handleContactSubmit()">Submit</button>
    </div>
  </div>

</div>

<div class="modal" id="contact-submit-modal">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Status</p>
      <button class="delete" aria-label="close"></button>
    </header>
    <section class="modal-card-body" style="overflow: hidden;">
      <!-- Content ... -->
      <div class="modal-content is-flex is-flex-direction-row is-justify-content-center"></div>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-success">Close</button>
    </footer>
  </div>
</div>

